<template>
  <v-select
    ref="serviceSelector"
    :options="packageList"
    label="name"
    placeholder="SELECT SERVICE"
    :filter="filterService"
    :value="value"
    @input="singlePackageSelect"
  >
    <template v-slot:option="option">
      <div class="kt-widget4__info">
        <div class="kt-widget1__title">
          <b>{{ option.name }}</b>
        </div>
        <div class="kt-widget1__sub">
          {{ option.description }}
        </div>
      </div>
    </template>
  </v-select>
</template>

<script>
import Fuse from 'fuse.js'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'ServiceSelector',
  components: {
    'v-select': VueSelect
  },
  props: { value: String, packageList: Array },
  methods: {
    singlePackageSelect (event) {
      const data = Object.assign({}, event)
      if (Object.entries(data).length > 0 && data.constructor === Object) {
        this.$emit('input', data)
      } else {
        this.$emit('input', null)
      }
    },
    multipleSelectService (event) {
      this.$emit('input', event)
    },
    filterService (option, search) {
      return new Fuse(option, {
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['name', 'serviceId', 'description']
      }).search(search)
    }
  }
}
</script>
